import styled from 'styled-components'

export const SubNavContainer = styled.div`
  background-color: white;
  padding: ${props => props.theme.spacings.medium} 0;
  box-shadow: ${props => props.theme.shadows.middle};
  margin-bottom: ${props => props.theme.spacings.medium};
`
